export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
          关于我们
        </h2>
        <div className="mt-8 bg-background-100 rounded-xl border border-background-200/70 p-8 md:p-10 text-left">
          <p className="text-sm text-foreground-600 leading-relaxed">
            91在线视频致力于打造国内领先的国产影视资源聚合平台。我们汇聚了超过
            <strong className="text-foreground-900 font-semibold">12,800部</strong>
            国产电影、电视剧、综艺和纪录片内容，每日更新
            <strong className="text-foreground-900 font-semibold">60部以上</strong>
            最新资源。
          </p>
          <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
            平台以"免费、高清、不缓冲"为核心承诺，通过智能分发技术确保每一位用户都能享受流畅的观看体验。我们相信，优秀的国产影视作品值得被更多人看到，91在线视频将持续拓展内容库，为观众提供更丰富、更便捷的在线观影选择。
          </p>
          <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
            从经典老片到最新热剧，从冷门佳片到票房大片，91在线视频始终与国产影视行业同行，用心做好每一帧的呈现。
          </p>
        </div>
      </div>
    </section>
  );
}